import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import gameActions from 'redux/actions/gameActions'
import { localize } from 'helpers/translator'

const GameActivityDeleteConfirm = props => (
	<Confirm
		btOne={localize('global_no')}
		btTwo={localize('global_yes')}
		alertMessage={localize('timeToClimb_creation_deleteQuestion_confirm')}
		actionButtonType={0}
		actionOne={props.actions.deleteActivityCancel}
		actionTwo={() => props.actions.deleteActivityConfirm(props.activityId)}
		closeAction={props.actions.deleteActivityCancel}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		deleteActivityCancel: gameActions.deleteActivityCancel,
		deleteActivityConfirm: gameActions.deleteActivityConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GameActivityDeleteConfirm)

export { GameActivityDeleteConfirm }
